import { GET_LOCATIONS_MANAGER } from '../../actions';

const getInitialState = {
  get: { error: null, loaded: false, loading: false, data: [] },
};

/**
 * locationsManager reducer.
 * @function locationsManager
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const locationsManagerReducer = (
  state = getInitialState,
  action = {},
) => {
  switch (action.type) {
    case `${GET_LOCATIONS_MANAGER}_PENDING`:
      return {
        ...state,
        get: {
          ...state.get,
          error: null,
          loaded: false,
          loading: true,
          data: [],
        },
      };
    case `${GET_LOCATIONS_MANAGER}_FAIL`:
      return {
        ...state,
        get: {
          ...state.get,
          error: action.error,
          loaded: false,
          loading: false,
          data: [],
        },
      };
    case `${GET_LOCATIONS_MANAGER}_SUCCESS`:
      return {
        ...state,
        get: {
          ...state.get,
          error: null,
          loaded: true,
          loading: false,
          data: action.result,
        },
      };
    default:
      return state;
  }
};
